export type Locale = 'en'

export const LOCALE_STORAGE_KEY = 'prime-shop-locale'

const messages = {
	en: {
		button: 'go to bot',
		botsUnavailable:
			'Stay with us — all our bots are temporarily unavailable. Save this page and check back soon.',
		notice:
			"Here you'll find the current link to our bot. Save this tab in your browser to always have a fresh link.",
		langRu: 'RU',
		langEn: 'ENG',
		langSwitch: 'Language',
	},
} as const satisfies Record<Locale, Record<string, string>>

export function t(locale: Locale) {
	return messages[locale]
}

export function readStoredLocale(): Locale {
	try {
		const stored = localStorage.getItem(LOCALE_STORAGE_KEY)
		if (stored === 'en') return stored
	} catch (error) {
		console.error('Failed to read locale from storage:', error)
	}
	return 'en'
}
